import {
    Box,
    Flex,
    Image,
    Text,
    useColorModeValue,
    Badge,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import RentalStatus from "./RentalStatus";
import { FaEye, FaClipboardList } from 'react-icons/fa';

export default function RentalItem(props) {
    const {id, title, place, pictures, status, booking_request_count, rental_request_count, teaser_picture} = props.rental;
    const textColor = useColorModeValue("navy.700", "white");
    return (
        <Card p='20px'>
            <Flex direction={{base: "column"}} justify='center'>
                <Box mb={{base: "20px", "2xl": "20px"}} position='relative'>
                    <Badge bgColor='white' position='absolute' top='5' right='5' cursor='pointer'>
                        <RentalStatus status={ status } ></RentalStatus>
                    </Badge>
                    <Image
                        src={teaser_picture}
                        w={{base: "100%", "3xl": "100%"}}
                        h={{base: "100%", "3xl": "100%"}}
                        borderRadius='20px'
                        objectFit='cover'
                        aspectRatio='1'
                        bgColor='grey'
                    />
                </Box>
                <Flex flexDirection='column' justify='space-between' h='100%'>
                    <Flex
                        justify='space-between'
                        direction={{
                            base: "row",
                            md: "column",
                            lg: "row",
                            xl: "column",
                            "2xl": "row",
                        }}
                        mb='auto'>
                        <Flex direction='column'>
                            <Text
                                color={textColor}
                                fontSize={{
                                    base: "xl",
                                    md: "lg",
                                    lg: "lg",
                                    xl: "lg",
                                    "2xl": "md",
                                    "3xl": "lg",
                                }}
                                mb='5px'
                                fontWeight='bold'
                                me='14px'>
                                {title}
                            </Text>
                            <Text
                                color='secondaryGray.600'
                                fontSize={{
                                    base: "sm",
                                }}
                                fontWeight='400'
                                me='14px'>
                                {place}
                            </Text>
                            <Flex
                                color='secondaryGray.600'
                                fontSize='sm'
                                alignItems='center'
                                justifyContent='end'
                                gap='1'>
                                <Flex alignItems='center' gap='1' title={`${rental_request_count} Seitenaufrufe`}><FaEye /> {rental_request_count}</Flex>
                                <Flex alignItems='center' gap='1' title={`${booking_request_count} Buchungsanfragen`}><FaClipboardList/> {booking_request_count}</Flex>
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </Card>
    );
}
